import classNames from "classnames"

export const InspectorPanelAccordionSubsections = ({
    children,
}: React.HTMLAttributes<HTMLDivElement>) => {
    const sanitizedChildren = Array.isArray(children) ? children.filter(Boolean) : children
    return (
        <div className="flex flex-col py-2">
            {Array.isArray(sanitizedChildren)
                ? sanitizedChildren.map((child, i) => (
                      <div
                          key={i}
                          className={classNames("px-2.5", {
                              "border-b border-gray-700 pb-2": i < sanitizedChildren.length - 1,
                              "pt-2": i > 0,
                          })}
                      >
                          {child}
                      </div>
                  ))
                : children && <div className="px-2.5">{children}</div>}
        </div>
    )
}
